import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LeaveBagsAtHomeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"leave_bags_at_home"}/>
}
